import { Component, ErrorInfo, ReactNode } from 'react';
import Alert from '@cloudscape-design/components/alert';
import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <Box padding="xl">
          <Alert
            type="error"
            header="Something went wrong"
            action={
              <Button onClick={() => this.setState({ hasError: false, error: null })}>
                Try again
              </Button>
            }
          >
            {this.state.error?.message || 'An unexpected error occurred.'}
          </Alert>
        </Box>
      );
    }

    return this.props.children;
  }
}
